import type { FC, ReactNode } from 'react'
import { useState } from 'react'
import { CollapsibleContent, useLazyContent } from '../../shared'

interface LazyCollapsibleContentProps {
  readonly content: string
  readonly children: (displayContent: string) => ReactNode
  readonly enableCollapse?: boolean
  readonly previewThreshold?: number
}

export const LazyCollapsibleContent: FC<LazyCollapsibleContentProps> = ({
  content,
  children,
  enableCollapse = true,
  previewThreshold = 30,
}) => {
  const [expanded, setExpanded] = useState(false)
  const { displayContent, shouldShowMore } = useLazyContent({
    content,
    expanded: !enableCollapse || expanded,
    previewThreshold,
  })

  return (
    <CollapsibleContent
      shouldCollapse={enableCollapse && shouldShowMore}
      expanded={expanded}
      onExpandChange={setExpanded}
    >
      {children(displayContent)}
    </CollapsibleContent>
  )
}
